var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA3EmbeddedFloorLampOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7v62h62V7H7zm58 58H52v-5h-5.45a8.412 8.412 0 10-16.8 0H24v5H11V11h54v54zm-22.47-5h-8.77a4.34 4.34 0 011-3 4.398 4.398 0 013-1.55h.37a4.41 4.41 0 014.39 4c.013.183.017.367.01.55z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A3_Embedded_floor_lamp_off.7918458e.svg";
export { SvgA3EmbeddedFloorLampOff as ReactComponent };